export default "__VITE_ASSET__Dpo5CVhB__"